import React, {Component} from "react";
import PropTypes from "prop-types";
import {formatMnDate} from "@mnjsplatform/data/lib/utils/formatData";
import textUtils from "@mnjsplatform/data/lib/utils/textUtils";
import {connect} from "react-redux";
import PopupWrapper from "../Common/PopupWrapper";
import ReactToPrint from "react-to-print";
import i18next from "i18next";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import "../../styles/VacationPrintPopupStyles.css";

class VacationPrintPopup extends Component {
    constructor(props, context) {
        super(props, context);

        this.refForPrint = React.createRef();
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.holidayAppPrint.reset());
            await this.props.dispatch(this.props.holidayAppPrint.execute(this.props.vacationKey, {
                withParams: false,
                newItem: true
            }));

            let textAreaArray = document.getElementsByTagName("textarea");
            for (let i = 0; i < textAreaArray.length; i++) {
                this.adjustHeight(textAreaArray[i]);
            }
        } catch (e) {
            console.error(e);
        }
    };

    adjustHeight = (ta) => {
        if (ta.rows > 1) {
            ta.rows--;
        }
        while (ta.clientHeight < ta.scrollHeight) {
            ta.rows++;
        }
    };

    textAreaTextChanged = async (e, fieldName) => {
        this.adjustHeight(e.target);
        await this.props.dispatch(this.props.holidayAppPrint.setField(0, fieldName, e.currentTarget.value));
    };

    renderTextArea = (h, fieldName) => {
        return (
            <textarea className="w-100 p-0"
                      rows={1}
                      value={h.row[fieldName] || ""}
                      onChange={e => this.textAreaTextChanged(e, fieldName)}
            />
        );
    };

    renderHeader = (h) => {
        return (
            <table className="mn-report-header">
                <tbody>
                <tr>
                    <td>
                        {this.renderTextArea(h, "SendTo_ProfName")}
                        <hr/>
                        {this.renderTextArea(h, "SelfCompany")}
                        <hr/>
                        {this.renderTextArea(h, "SendTo_FIO")}
                        <hr/>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div className="d-flex justify-content-end align-items-end">
                            <div>{i18next.t("From")}</div>
                            &nbsp;
                            {this.renderTextArea(h, "ProfessionName")}
                        </div>
                        <hr/>
                    </td>
                </tr>
                <tr>
                    <td className="mn-report-header-line">
                        {this.renderTextArea(h, "DepartmentName")}
                        <hr/>
                        <div>
                            <sub className="ml-50px">({i18next.t("HolidayAppSendToTitleDepartament_Label")})</sub>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className="mn-report-header-line">
                        {this.renderTextArea(h, "FIO")}
                        <hr/>
                        <div>
                            <sub className="ml-50px">({i18next.t("HolidayAppSendToPreferredName_Label")})</sub>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className="mn-report-header-line">
                        {i18next.t("TabNum_Label")}: {h.ed("TabNum")}&nbsp;
                        <hr/>
                    </td>
                </tr>
                </tbody>
            </table>
        );
    };

    renderHoliday = (h, i) => {
        switch (h.TypeHolidayGroup.toLowerCase()) {
            case 'regular':
                return (
                    <div key={i} className="mn-report-row">
                        {
                            i18next.t("Vacation_Print_1",
                                {
                                    itemName: h.ItemName,
                                    dateBegin: formatMnDate(h.DateBegin),
                                    days: textUtils.pluralize_i18next(h.NumDays, "calendarDaysCountPostfix")
                                })
                        }
                    </div>
                );
            case 'extraordinary':
                return (
                    <div key={i} className="mn-report-row">
                        {
                            i18next.t("Vacation_Print_1",
                                {
                                    itemName: h.ItemName,
                                    dateBegin: formatMnDate(h.DateBegin),
                                    days: textUtils.pluralize_i18next(h.NumDays, "daysCountPostfix")
                                })
                        }
                    </div>
                );
            case 'compensation':
                return (
                    <div key={i} className="mn-report-row">
                        {
                            i18next.t("Vacation_Print_2",
                                {
                                    itemName: h.ItemName?.replace(i18next.t("Vacation_Print_Popup_1"), i18next.t("Vacation_Print_Popup_2")),
                                    dateBegin: formatMnDate(h.DateBegin),
                                    days: textUtils.pluralize_i18next(h.NumDays, "daysCountPostfix")
                                })
                        }
                    </div>
                );
            default:
                return null;
        }
    }

    renderBody = (holidaysItem) => {
        return (
            <div className="mn-report-body">
                <div className="text-center" style={{marginBottom: "50px"}}>
                    <h3>{i18next.t("Request")}</h3>
                </div>
                {holidaysItem.dataTable().map((h, i) => this.renderHoliday(h, i))}
            </div>
        );
    };

    renderSignature = (h) => {
        return (
            <table className="mn-report-signature">
                <tbody>
                <tr>
                    <td className="text-right">
                        {i18next.t("Date")}:
                    </td>
                    <td>
                        <div className="report-date">
                            {h.ed("DateCreate")}
                        </div>
                        <hr/>
                    </td>
                </tr>
                <tr>
                    <td className="text-right">
                        {i18next.t("EmployeeSignature")}:
                    </td>
                    <td style={{lineHeight: "30px"}}>
                        &nbsp;
                        <hr/>
                    </td>
                </tr>
                <tr>
                    <td className="text-right">
                        {i18next.t("Vacation_Print_3")}:
                    </td>
                    <td className="text-center ChiefFIOHolder">
                        <div>{h.ed("ChiefFIO")}</div>
                        <hr/>
                    </td>
                </tr>
                <tr>
                    <td>&nbsp;</td>
                    <td className="text-center">
                        <sub>({i18next.t("Vacation_Print_4")})</sub>
                    </td>
                </tr>
                </tbody>
            </table>
        );
    };

    renderPrintForm = (h) => {
        return (
            <div id="vacationPrintForm" className="mn-report" ref={this.refForPrint}>
                {this.renderHeader(h)}
                {this.renderBody(this.props.holidayList)}
                {this.renderSignature(h)}
            </div>
        );
    };

    renderPopupButtons = () => {
        return (<div className="modal-footer text-right">
            <ReactToPrint
                trigger={() => <button type="button"
                                       className="btn btn-regular -goahead ml1ex">{i18next.t("Print")}</button>}
                content={() => this.refForPrint.current}
            />

            <button type="button" className="btn btn-regular"
                    onClick={this.props.onClose}>{i18next.t("Close")}</button>
        </div>)
    };

    render() {
        return (
            <PopupWrapper popupVisible={true}
                          title={this.props.title}
                          staticTitle={i18next.t("PrintVacationStatement")}
                          renderButtons={this.renderPopupButtons}
                          onClose={this.props.onClose}
            >
                <ComplexParam dataItem={this.props.holidayAppPrint}
                              showApplyButton={false} showSearchBar={false} readOnly={false}
                              renderParams={this.renderPrintForm}
                />
            </PopupWrapper>
        );
    }
}

VacationPrintPopup.propTypes = {
    dispatch: PropTypes.func.isRequired,
    holidayList: PropTypes.object.isRequired,
    vacationKey: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string,
    holidayAppPrint: PropTypes.object
};

VacationPrintPopup.defaultProps = {
    title: i18next.t("PrintVacationStatement")
};

function mapStateToProps(state, ownProps) {
    return {
        holidayAppPrint: state.vacationState.HolidayAppPrint
    }
}

export default connect(mapStateToProps)(VacationPrintPopup);